import React, { useEffect } from 'react';
import StickyTopBar from '../../../utils/topbarBehaviour';

import Footer from '../../Footer';
import Navbar from '../../Navbar';
import './MainLayout.scss';

interface IMainLayout {
  children: React.ReactNode;
}

const MainLayout = ({ children }: IMainLayout) => {
  useEffect(() => {
    if (window) {
      StickyTopBar();
    }
  }, []);

  return (
    <div className="page-container">
      <div className="content-wrap">
        <Navbar />
        <div className="mt-16">{children}</div>
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
